import { getQueryParamsString } from '../../utils/utils';
import { apiGqAdminClient } from './axios';
import { routes } from './routes';

// Auth
export const authPlatformAuthorizeV01Post = (body) => {
    return apiGqAdminClient({
        method: routes.AUTHENTICATION_PLATFORM_AUTHORIZE_V01.METHOD,
        url: routes.AUTHENTICATION_PLATFORM_AUTHORIZE_V01.URL,
        data: body,
    });
};

// Payment Pages
export const paymentPagesFetchGet = (searchObj = null) => {
    let queryString='';
    if (searchObj) {
        queryString = getQueryParamsString(searchObj);
    }
    return apiGqAdminClient({
        method: routes.PAYMENT_PAGES_FETCH.METHOD,
        url: `${routes.PAYMENT_PAGES_FETCH.URL}${queryString ? `?${queryString}` : ''}`,
    });
};

export const paymentPagesFeeTypesFetchGet = (searchObj = null) => {
    let queryString='';
    if (searchObj) {
        queryString = getQueryParamsString(searchObj);
    }
    return apiGqAdminClient({
        method: routes.PAYMENT_PAGES_FEE_TYPES_FETCH.METHOD,
        url: `${routes.PAYMENT_PAGES_FEE_TYPES_FETCH.URL}${queryString ? `?${queryString}` : ''}`,
    });
};

export const checkboxFeeTypesFetchGet = (searchObj = null) => {
    let queryString='';
    if (searchObj) {
        queryString = getQueryParamsString(searchObj);
    }
    return apiGqAdminClient({
        method: routes.CHECKBOX_FEE_TYPES_FETCH.METHOD,
        url: `${routes.CHECKBOX_FEE_TYPES_FETCH.URL}${queryString ? `?${queryString}` : ''}`,
    });
};

export const paymentPagesFeeTypesCalculatePost = (body = null) => {
    return apiGqAdminClient({
        method: routes.PAYMENT_PAGES_FEE_TYPES_CALCULATE.METHOD,
        url: `${routes.PAYMENT_PAGES_FEE_TYPES_CALCULATE.URL}${body?.payment_page_slug ? `?payment_page_slug=${body?.payment_page_slug}` : ''}`,
        data: body,
    });
};

// Form Editor / Form Fields
export const formEditorFormFieldsUpdatePatch = (body) => {
    return apiGqAdminClient({
        method: routes.FORM_EDITOR_FORM_FIELDS_UPDATE.METHOD,
        url: routes.FORM_EDITOR_FORM_FIELDS_UPDATE.URL,
        data: body,
    });
};


// Student
export const studentsGet = (searchObj = null) => {
    const queryString = getQueryParamsString(searchObj);
    return apiGqAdminClient({
        method: routes.STUDENTS_FETCH.METHOD,
        url: `${routes.STUDENTS_FETCH.URL}${queryString ? `?${queryString}` : ''}`,
    });
};

export const studentsFieldDetailsGet = (searchObj = null) => {
    const queryString = getQueryParamsString(searchObj);
    return apiGqAdminClient({
        method: routes.STUDENTS_FIELD_DETAILS_FETCH.METHOD,
        url: `${routes.STUDENTS_FIELD_DETAILS_FETCH.URL}${queryString ? `?${queryString}` : ''}`,
    });
};

export const studentsCreatePost = (body) => {
    return apiGqAdminClient({
        method: routes.STUDENTS_CREATE.METHOD,
        url: routes.STUDENTS_CREATE.URL,
        data: body,
    });
};

export const studentsWrapperCreatePost = (body) => {
    return apiGqAdminClient({
        method: routes.STUDENTS_WRAPPER_CREATE.METHOD,
        url: routes.STUDENTS_WRAPPER_CREATE.URL,
        data: body,
    });
};

export const studentsReceiptFetch = (searchObj = null) => {
    let queryString='';
    if (searchObj) {
        queryString = getQueryParamsString(searchObj);
    }
    return apiGqAdminClient({
        method: routes.STUDENTS_RECEIPT_FETCH.METHOD,
        url: `${routes.STUDENTS_RECEIPT_FETCH.URL}${queryString ? `?${queryString}` : ''}`,
    });
};

// GILE Class
export const gileClassesFetchGet = (searchObj = null) => {
    let queryString='';
    let group_code='';
    if (searchObj) {
        group_code = searchObj?.group_code;
        delete searchObj.group_code;
        queryString = getQueryParamsString({ ...searchObj, dropdown: 'true'});
    }
    return apiGqAdminClient({
        method: routes.GILE_CLASSES_FETCH.METHOD,
        url: `${routes.GILE_CLASSES_FETCH.URL}/${group_code}/classes/fetch${queryString ? `?${queryString}` : ''}`,
    });
};

// Update customer mobile
export const customerDetailsUpdateMobilePatch = (body) => {
    return apiGqAdminClient({
        method: routes.CUSTOMER_DETAILS_UPDATE_MOBILE_PATCH.METHOD,
        url: routes.CUSTOMER_DETAILS_UPDATE_MOBILE_PATCH.URL,
        data: body,
    });
};

// export const paymentPagesListFetchGet = (searchObj = null) => {
//     let queryString='';
//     let group_code='';
//     if (searchObj) {
//         group_code = searchObj?.group_code;
//         delete searchObj.group_code;
//         queryString = getQueryParamsString(searchObj);
//     }
//     return apiGqAdminClient({
//         method: routes.PAYMENT_PAGES_LIST_FETCH.METHOD,
//         url: `${routes.PAYMENT_PAGES_LIST_FETCH.URL}/${group_code}list/fetch${queryString ? `?${queryString}` : ''}`,
//     });
// };